import { useState } from "react";
import ModalNew from "../popup/Modal";
import { PopupContent, PopupHeader } from "../popup/common";
import TermsConditions from "../../../pages/publics/TermsConditions";
import Privacy from "../../../pages/publics/Privacy";

const LEGAL_LINKS = {
  terms: {
    href: "/terms-conditions",
    title: "Terms & Conditions",
    Content: TermsConditions,
  },
  privacy: {
    href: "/privacy-policy",
    title: "Privacy Policy",
    Content: Privacy,
  },
};

function TermsConsentNotice() {
  const [activeLegal, setActiveLegal] = useState(null);

  const openLegalModal = (event, legalKey) => {
    event.preventDefault();
    setActiveLegal(LEGAL_LINKS[legalKey]);
  };

  const closeLegalModal = () => {
    setActiveLegal(null);
  };

  return (
    <>
      <p className="auth-terms-consent">
        By continuing, I agree to Plaintr&apos;s{" "}
        <a
          href={LEGAL_LINKS.terms.href}
          className="auth-terms-consent-link"
          onClick={(event) => openLegalModal(event, "terms")}
        >
          Terms & Conditions
        </a>{" "}
        and{" "}
        <a
          href={LEGAL_LINKS.privacy.href}
          className="auth-terms-consent-link"
          onClick={(event) => openLegalModal(event, "privacy")}
        >
          Privacy Policy
        </a>
        .
      </p>

      {activeLegal && (
        <ModalNew className="content-modal" style={{ maxWidth: "700px" }}>
          <PopupHeader
            title={activeLegal.title}
            setOpenState={(isOpen) => {
              if (!isOpen) closeLegalModal();
            }}
            icon={`${process.env.PUBLIC_URL}/images/icons/doc_blue_popup.svg`}
            variant="compact"
          />
          <PopupContent maxHeight="70vh">
            <activeLegal.Content embed />
          </PopupContent>
        </ModalNew>
      )}
    </>
  );
}

export default TermsConsentNotice;
